import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import NProgress from "nprogress";
import "nprogress/nprogress.css";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/about",
    name: "About",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
  {
    path: "/start",
    name: "Start",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Start.vue"),
  },
  {
    path: "/installation",
    name: "Installation",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Installation.vue"),
  },
  {
    path: "/paintings",
    name: "Paintings",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Paintings.vue"),
  },
  {
    path: "/paperworks",
    name: "Paperworks",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Paperworks.vue"),
  },
  {
    path: "/music",
    name: "Music",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Music.vue"),
  },
  {
    path: "/video",
    name: "Video",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Video.vue"),
  },
  {
    path: "/shop",
    name: "Shop",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Shop.vue"),
  },
  {
    path: "/about",
    name: "About",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
  {
    path: "/contact",
    name: "Contact",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Contact.vue"),
  },
  {
    path: "/imprint",
    name: "Imprint",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Imprint.vue"),
  },
  {
    path: "/news",
    name: "News",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/News.vue"),
  },
  {
    path: "/borneronfire",
    name: "Borneronfire",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Borneronfire.vue"),
  },
  {
    path: "/heaven67",
    name: "Heaven67",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Heaven67.vue"),
  },
  {
    path: "/intershop",
    name: "Intershop",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Intershop.vue"),
  },
  {
    path: "/tattoo",
    name: "Tattoo",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Tattoo.vue"),
  },
  {
    path: "/writing",
    name: "Writing",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Writing.vue"),
  },
  {
    path: "/texts",
    name: "Texts",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Texts.vue"),
  },
  {
    path: "/fashion",
    name: "Fashion",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Fashion.vue"),
  },
  {
    path: "/links",
    name: "Links",
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/Links.vue"),
  },
];

const router = new VueRouter({
  //mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeResolve((to, from, next) => {
  if (to.name) {
    NProgress.start();
  }
  next();
});

router.afterEach((to, from) => {
  NProgress.done();
});

export default router;
